import PropTypes from 'prop-types'
import usePaymentMethods from '~/react/hooks/usePaymentMethods'
import NoKyc from './NoKyc'
import OnboardingIncomplete from './OnboardingIncomplete'
import NoActivePaymentMethod from './NoActivePaymentMethod'

export const Alerts = ({
  verificationStatus,
  completedOnboarding,
  supplierId,
  accountingProviderName,
}) => {
  const {
    processingPaymentMethods,
    paymentMethods: activePaymentMethods,
    isLoading: isLoadingPaymentMethods,
  } = usePaymentMethods(supplierId)

  const showKycAlert = verificationStatus !== 'verified'

  // Suppliers without an active payment method should see the payment method alert instead of the onboarding alert, even if they can't make payments, since the most likely reason they can't make payments is because they don't have an active payment method.
  const showOnboardingAlert = !completedOnboarding

  const showPaymentMethodAlert =
    !isLoadingPaymentMethods && !activePaymentMethods.length

  if (showKycAlert) {
    return <NoKyc />
  }

  if (showOnboardingAlert) {
    return (
      <OnboardingIncomplete accountingProviderName={accountingProviderName} />
    )
  }

  if (showPaymentMethodAlert) {
    return (
      <NoActivePaymentMethod
        isProcessingPaymentMethod={!!processingPaymentMethods.length}
      />
    )
  }

  return null
}

Alerts.propTypes = {
  verificationStatus: PropTypes.string.isRequired,
  completedOnboarding: PropTypes.bool.isRequired,
  supplierId: PropTypes.string.isRequired,
  accountingProviderName: PropTypes.string.isRequired,
}

export default Alerts
